import { supabase } from '../lib/supabase';

export type EmploymentType = 'full_time' | 'part_time' | 'arbetsformedlingen';

export type ProvisionDriverInput = {
  full_name: string;
  email: string;
  driver_code: string;
  phone?: string;
  license_no?: string;
  company_id?: string;
  vehicle_id?: string;
  employment_type?: EmploymentType;
  is_insured?: boolean;
  insurance_company?: string;
  insurance_policy_no?: string;
  password?: string;
  send_email?: boolean;
};

export type ProvisionDriverResult = {
  driver_id: string;
  driver_code: string;
  email: string;
  password: string;
};

export function useProvisionDriver() {
  async function provisionDriver(input: ProvisionDriverInput) {
    // RPC first — avoids CORS noise when Edge Functions are not deployed
    const { data: rpcData, error: rpcErr } = await supabase.rpc('provision_driver_dashboard', {
      p_full_name: input.full_name,
      p_email: input.email,
      p_driver_code: input.driver_code,
      p_phone: input.phone ?? null,
      p_license_no: input.license_no ?? null,
      p_company_id: input.company_id ?? null,
      p_vehicle_id: input.vehicle_id ?? null,
      p_employment_type: input.employment_type ?? null,
      p_is_insured: input.is_insured ?? false,
      p_insurance_company: input.insurance_company ?? null,
      p_insurance_policy_no: input.insurance_policy_no ?? null,
      p_password: input.password ?? null,
      p_send_email: input.send_email ?? false,
    });

    if (!rpcErr && rpcData && (rpcData as ProvisionDriverResult).driver_code) {
      const payload = rpcData as ProvisionDriverResult & { password?: string };
      return {
        data: {
          driver_id: payload.driver_id,
          driver_code: payload.driver_code,
          email: payload.email,
          password: payload.password ?? input.password ?? 'Vilotid123!',
        },
        error: null,
      };
    }

    const { data, error } = await supabase.functions.invoke('provision-driver', {
      body: input,
    });

    if (!error && data && !(data as { error?: string }).error && (data as ProvisionDriverResult).driver_code) {
      return { data: data as ProvisionDriverResult, error: null };
    }

    const edgeMsg = error?.message ?? '';
    return {
      data: null,
      error: rpcErr?.message || edgeMsg || 'Provisioning failed — apply migration 023 in Supabase SQL Editor',
    };
  }

  return { provisionDriver };
}
